import itemStyle from './treemap.breadcrumb.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    itemStyle,
  },
}
